<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @choose-change="chooseChange"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
export default {
  components: {
    PageHeader,
    PageMain,
  },
  mixins: [BaseTable],
  props: {
    orgCode: {type: String, default: ''},
    depCode: {type: String, default: ''},
  },
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.chooseChange(null)
      this.loading = true
      this.$api
        .sysDepartmentListByChooseApi({
          ...form,
          ...this.page,
          orgCode: this.orgCode,
          depCode: this.depCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    chooseChange(data) {
      this.$emit('choose-change', data)
    },
  },
}
</script>
